<div id="dept-english" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of English</h2>
    <p class="inner-lead mt-3">
      The Department of English at Shah Satnam Ji Girls' College, Sirsa fosters strong communication skills, literary appreciation and critical thinking in students. The department offers English at both undergraduate and postgraduate levels.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>BA English (UG) — 3 Years</li>
      <li>English as a subject in BBA, B.Com, B.Sc, BCA, BAJMC</li>
      <li>MA English (PG) — 2 Years</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
            <th>Designation</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Dr. Monika</td><td>MA English, M.Phil, B.Ed., PhD</td><td>HOD</td></tr>
          <tr><td>2</td><td>Ms. Gurdeep</td><td>MA English</td><td>Assistant Professor</td></tr>
          <tr><td>3</td><td>Ms. Muskan Bajaj</td><td>MA English, B.Ed</td><td>Assistant Professor</td></tr>
          <tr><td>4</td><td>Ms. Dheeraj Pal Kaur</td><td>MA English, B.Ed</td><td>Assistant Professor</td></tr>
          <tr><td>5</td><td>Ms. Kamlesh</td><td>MA English, B.Ed, UGC-NET</td><td>Assistant Professor</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2023–24</h5>
    <ul class="inner-lead">
      <li>World Poetry Day Celebration</li>
      <li>Extension Talk on Communication Skills</li>
    </ul>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2022–23</h5>
    <ul class="inner-lead">
      <li>Health and Fitness Workshop</li>
      <li>World Poetry Day Celebration</li>
      <li>Book Reading Competition</li>
      <li>Literary Quiz</li>
    </ul>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2021–22</h5>
    <ul class="inner-lead">
      <li>FDP on Advanced Leadership Skills and Creative Thinking</li>
    </ul>

  </div>
</div>
